function a(){return null!=navigator.languages?navigator.languages[0]:navigator.language}export{a as default};
